export const getApiBaseUrl = () => {
  return window.location.hostname === 'localhost' 
    ? 'http://localhost:5000' 
    : 'https://api.zenkroll.co.mz';
};

export const getDocumentUrl = (filename, isView = false) => {
  if (!filename) {
    throw new Error('Filename é obrigatório');
  }
  
  // Limpar o filename - remover caminhos se houver
  const cleanFilename = filename.split('\\').pop().split('/').pop();
  const baseUrl = getApiBaseUrl();
  
  return isView 
    ? `${baseUrl}/api/documentos/view/${cleanFilename}`
    : `${baseUrl}/api/documentos/${cleanFilename}`;
};